import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({ title, subtitle, moreTo, moreLabel = '查看全部' }: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between mb-5">
      <div>
        <h2 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950 flex items-center gap-2">
          <span className="w-1 h-6 rounded-full bg-primary-500"></span>
          {title}
        </h2>
        {subtitle && <p className="text-sm text-foreground-500 mt-1.5">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}